import React from "react";
import "../../App.css";
import PackingTypeMaster from "../PackingTypeMaster";

function PackingTypeMasterPage({ sessionObject }) {
  if (
    !sessionObject.sessionVariables["modules"].includes("packing_type_master")
  ) {
    return;
  }
  return (
    <div className="page-vehicle">
      <PackingTypeMaster sessionObject={sessionObject} />
    </div>
  );
}

export default PackingTypeMasterPage;
